import { defineStore } from 'pinia'
import MarketStoreI, { MarketState } from '@/modules/market/types/store/MarketStoreI'
import { ProductI } from '@/modules/market/types/api/MarketStoreTypes'
import CustomiseProductOptions from '@/modules/cart/entities/CostomiseProductOptions'

export const useMarketStore: MarketStoreI = defineStore('market', {
  state: () =>
    ({
      productsGroups: [],
      products: [],
      chosenProduct: null,
    }) as MarketState,
  getters: {
    getProductsGroups(state) {
      return state.productsGroups ?? null
    },
    getProducts(state) {
      return state.products ?? null
    },
    getChosenProduct(state) {
      return state.chosenProduct ?? null
    },
    getVpcPAYGProductsInformation(state) {
      return state.products.find((el: ProductI) => el.slug === 'vpc-payg')
    },
  },
  actions: {
    async loadProductsGroups() {
      try {
        const response = await this.$services.market.getProductsGroups()
        if (response instanceof Error) {
          return response
        }
        this.productsGroups = response
      } catch (e) {
        console.log('loadProductsGroups error: ', e)
      }
    },
    async loadProducts(slug) {
      try {
        const response = await this.$services.market.getProducts(slug)
        if (response instanceof Error) {
          return response
        }
        this.products = response
      } catch (e) {
        console.log('loadProducts error: ', e)
      }
    },
    /**
     * A product's configurable options, for a store page that prices a configuration before the
     * cart does (the Custom VPS card). Returned, not kept: the cart loads its own copy. Null when
     * the options cannot be read.
     */
    async loadProductOptions(slug: string) {
      try {
        return new CustomiseProductOptions(await this.$services.cart.getProductOptions(slug))
      } catch (e) {
        console.log('loadProductOptions error: ', e)
        return null
      }
    },
    updateChosenProduct(product: ProductI | null) {
      this.chosenProduct = product
    },
  },
})
